import React from 'react';
import PropTypes from 'prop-types';
import { financeTypeSpecificContent, commonContent } from './financeTypeInfo';

const FinanceDrawer = ({ financeType, closeModal }) => {
  return (
    <div className="ch-modal ch-modal--drawer ac-finance--drawer">
      <div className="ch-modal__header">
        {financeType === 'pcp' ? (
          <h1 className="ch-fs--4 ch-mb--0">
            Personal contract purchase <span className="ch-fw--400">(PCP)</span>
          </h1>
        ) : (
          <h1 className="ch-fs--4 ch-mb--0">
            Hire purchase <span className="ch-fw--400">(HP)</span>
          </h1>
        )}
        <button className="ch-modal__close" onClick={closeModal} type="button">
          <span className="ch-reader">Close</span>
        </button>
      </div>
      <div className="ch-modal__body ch-pa--2 ch-bg--grey-1">
        <p className="ch-fs--3">
          Everything you wanted to know about{' '}
          {financeType === 'pcp' ? 'PCP' : 'HP'} car finance.
        </p>
        <div className="ch-accordion">
          <details>
            <summary className="ch-shadow--sm ch-fs--4">Key features</summary>
            <div className="ch-accordion__content">
              <ul className="ch-list ch-list--tall">
                {financeTypeSpecificContent[financeType]['keyFeatures'].map(
                  (feature, key) => {
                    return <li key={key}>{feature}</li>;
                  },
                )}
              </ul>
            </div>
          </details>
          <details>
            <summary className="ch-shadow--sm ch-fs--4">Need to know</summary>
            <div className="ch-accordion__content">
              {Object.entries(
                financeTypeSpecificContent[financeType]['needToKnow'],
              ).map(([key, value]) => {
                return (
                  <div className="ch-pb--4" key={key}>
                    <h3>{key}</h3>
                    <p className="ch-mb--0">{value}</p>
                    {key === 'Mileage restrictions and charges' && (
                      <p className="ch-mb--0 ch-mt--2">
                        The guaranteed future value is set by the lender based
                        on the miles you expect to drive. Choose a realistic
                        mileage to avoid any charges.
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </details>
          <details>
            <summary className="ch-shadow--sm ch-fs--4">Terms we use</summary>
            <div className="ch-accordion__content">
              {Object.entries(commonContent.terms).map(([key, value]) => {
                return (
                  <div className="ch-pb--4" key={key}>
                    <h3>{key}</h3>
                    <p className="ch-mb--0">{value}</p>
                    {key === 'Representative APR' && (
                      <p className="ch-mb--0 ch-mt--2">
                        It&apos;s the rate most (but not all) customers should
                        get if approved for finance. It includes your fixed
                        interest and any fees to give you an idea of the cost of
                        financing your vehicle.
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </details>
          <details>
            <summary className="ch-shadow--sm ch-fs--4">FAQs</summary>
            <div className="ch-accordion__content">
              {Object.entries(commonContent.faqs).map(([key, value]) => {
                return (
                  <div className="ch-pb--4" key={key}>
                    <h3>{key}</h3>
                    <p className="ch-mb--0">{value}</p>
                  </div>
                );
              })}
            </div>
          </details>
        </div>
      </div>
      <div className="ch-modal__footer">
        <button
          className="ch-btn ch-btn--success ch-width--12"
          onClick={closeModal}
          type="button"
        >
          Back to your deal
        </button>
      </div>
    </div>
  );
};

export default FinanceDrawer;

FinanceDrawer.propTypes = {
  closeModal: PropTypes.func,
  financeType: PropTypes.string,
};
